import { render, staticRenderFns } from "./bullWiseSemenStorage.vue?vue&type=template&id=540714b6&scoped=true&"
import script from "./bullWiseSemenStorage.vue?vue&type=script&lang=js&"
export * from "./bullWiseSemenStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540714b6",
  null
  
)

export default component.exports